var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.buttonList.length>0)?_c('span',_vm._l((_vm.buttonList),function(item){return _c('el-button',{key:item.Name,attrs:{"value":item.Id,"type":"primary","size":"small","icon":item.Icon,"round":""},on:{"click":function($event){return _vm.callFunc(item)}}},[_vm._v(_vm._s(item.Name))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }